const searchReddit = async (query: string) => {
  const { items } = await fetch(
    `https://customsearch.googleapis.com/customsearch/v1?cx=${process.env.REACT_APP_GOOGLE_SEARCH_ENGINE_ID}&key=${process.env.REACT_APP_GOOGLE_CUSTOM_SEARCH_API_KEY}&q=${query}`
  ).then(r => r.json())
  return items
}

export default searchReddit
